import React from "react";
import Image from "next/image";
import Link from "next/link";
import { PostGalleryLinkProps } from "@/types/modules/post/components";
import { DottedSeparator } from "@/components/ui-kit/Decorations/DottedSeparator";

export const PostGalleryLink: React.FC<PostGalleryLinkProps> = ({ galleryCount, postId, postSlug }) => {
  return (
    <>
      <DottedSeparator />
      <div className="flex items-center justify-between border-b border-dark py-3 font-sans dark:border-white">
        <Link
          href={`/galerie/${postId}/${postSlug}`}
          className="flex items-center no-underline decoration-orange underline-offset-2 md:hover:underline"
        >
          <Image src="/assets/images/icons/camera.svg" alt="Camera Icon" width={20} height={20} />
          <span className="ml-2 text-md text-orange">{galleryCount}</span>
        </Link>
        <Link
          href={`/galerie/${postId}/${postSlug}`}
          className="flex items-center no-underline underline-offset-2 md:hover:underline"
        >
          <span className="mr-3 text-md text-dark dark:text-white">Fotogalerie k článku</span>
          <Image
            src="/assets/images/icons/chevron-right.svg"
            alt="Chevron Right"
            width={20}
            height={20}
            className="dark:invert"
          />
        </Link>
      </div>
    </>
  );
};
